import React, { useEffect, useRef, useState } from "react";

const ExpandableText = ({ text = "", type = "text" }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<any>(null);

  useEffect(() => {
    if (textRef.current) {
      const isTextOverflowing =
        textRef.current.scrollHeight > textRef.current.clientHeight;
      setIsOverflowing(isTextOverflowing);
    }
  }, [text]);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  return (
    <td>
      <div style={{ maxWidth: "100%" }}>
        {type === "html" ? (
          <div
            ref={textRef}
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              WebkitLineClamp: isExpanded ? "unset" : 2,
              whiteSpace: isExpanded ? "normal" : "pre-line",
            }}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          <div
            ref={textRef}
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              WebkitLineClamp: isExpanded ? "unset" : 2,
              whiteSpace: isExpanded ? "normal" : "pre-line",
            }}
          >
            {text}
          </div>
        )}

        {isOverflowing && (
          <button
            onClick={toggleExpand}
            style={{
              background: "none",
              border: "none",
              color: "royalblue",
              cursor: "pointer",
              padding: 0,
            }}
          >
            {isExpanded ? "Show Less" : "Show More"}
          </button>
        )}
      </div>
    </td>
  );
};

export default ExpandableText;
